export const dashboardRoute = "/dashboard";

export const editImportantDateRoute = `/school-years/:id`;
export const schoolYearListRoute = "/school-years";
export const editImportantDateUrl = (id: number) => `/school-years/${id}`;

export const schoolCandidateRoute = "/school-candidates";
export const schoolCandidateUrl = () => "/school-candidates";
export const schoolCandidateAddressAccessRoute = "/school-candidates-address-access";
export const schoolCandidateAddressAccessUrl = () => "/school-candidates-address-access";
export const schoolCandidateDetailRoute = `/school-candidates/:id`;
export const schoolCandidateDetailUrl = (id: number) =>
  `/school-candidates/${id}`;
export const schoolCandidateEditRoute = `/school-candidates/edit/:id`;
export const schoolCandidateEditUrl = (id: number) =>
  `/school-candidates/edit/${id}`;

export const schoolCandidateInstitutionSummaryListRoute =
  "/school-candidates-institutions";
export const schoolCandidateInstitutionListRoute = `/school-candidates-institutions/:id`;
export const schoolCandidateInstitutionListUrl = (id: number) =>
  `/school-candidates-institutions/${id}`;

export const schoolCandidateInstitutionReassignmentRoute =
  "/school-candidates-reassignment/:id";
export const schoolCandidateInstitutionReassignmentUrl = (id: number) =>
  `/school-candidates-reassignment/${id}`;

export const schoolCandidateInstitutionAdminListRoute = `/school-candidates-institutions-admin`;
export const schoolCandidateInstitutionAdminListUrl = () =>
  "/school-candidates-institutions-admin";
export const schoolCandidateInstitutionAdminDetailRoute = `/school-candidates-institutions-admin/:id`;
export const schoolCandidateInstitutionAdminDetailUrl = (id: number) =>
  `/school-candidates-institutions-admin/${id}`;
export const schoolCandidateInstitutionAdminEditRoute = `/school-candidates-institutions-admin/edit/:id`;
export const schoolCandidateInstitutionAdminEditUrl = (id: number) =>
  `/school-candidates-institutions-admin/edit/${id}`;

export const aboutProgramRoute = "/aboutprogram";
export const helpAndSupportRoute = "/help-and-support";
export const newErrorReporRoute = "/errorReport/new";
export const statementOfAccessibilityRoute = "/statement-of-accessibility";
export const privacyStatementRoute = "/privacy-statement";

export const faqGroupsAndItemsRoute = "/faq";
export const faqGroupListRoute = "/faq-group";
export const faqGroupDetailRoute = "/faq-group/:id";
export const faqGroupDetailUrl = (id: number) => `/faq-group/${id}`;
export const faqGroupEditRoute = "/faq-group/edit/:id";
export const faqGroupEditUrl = (id: number) => `/faq-group/edit/${id}`;
export const faqItemListRoute = "/faq-item";
export const faqItemDetailRoute = "/faq-item/:id";
export const faqItemDetailUrl = (id: number) => `/faq-item/${id}`;
export const faqItemEditRoute = "/faq-item/edit/:id";
export const faqItemEditUrl = (id: number) => `/faq-item/edit/${id}`;

export const announcementListRoute = "/announcement";
export const announcementDetailRoute = "/announcement/:id";
export const announcementDetailUrl = (id: number) => `/announcement/${id}`;
export const announcementEditRoute = "/announcement/edit/:id";
export const announcementEditUrl = (id: number) => `/announcement/edit/${id}`;

export const committeeListRoute = "/committee";
export const committeeDetailRoute = "/committee/:id";
export const committeeDetailUrl = (id: number) => `/committee/${id}`;
export const committeeEditRoute = "/committee/edit/:id/:institutionId?";
export const committeeEditUrl = (id: number, institutionId?: number) =>
  institutionId
    ? `/committee/edit/${id}/${institutionId}`
    : `/committee/edit/${id}`;
export const committeeApprovalListRoute = "/committee-approval";
export const committeeApprovalDetailRoute = "/committee-approval/:id";
export const committeeApprovalDetailUrl = (id: number) =>
  `/committee-approval/${id}`;
export const committeeApprovalEditRoute = "/committee-approval/edit/:id";
export const committeeApprovalEditUrl = (id: number) =>
  `/committee-approval/edit/${id}`;
export const countyCommitteeListRoute = "/committee-county";
export const countyCommitteeDetailRoute = "/committee-county/:id";
export const countyCommitteeDetailUrl = (id: number) =>
  `/committee-county/${id}`;
export const countyCommitteeEditRoute = "/committee-county/edit/:id/:countyId?";
export const countyCommitteeEditUrl = (id: number, countyId?: number) =>
  countyId
    ? `/committee-county/edit/${id}/${countyId}`
    : `/committee-county/edit/${id}`;
export const ministryCommitteeListRoute = "/committee-ministry";
export const ministryCommitteeDetailRoute = "/committee-ministry/:id";
export const ministryCommitteeDetailUrl = (id: number) =>
  `/committee-ministry/${id}`;
export const ministryCommitteeEditRoute = "/committee-ministry/edit/:id";
export const ministryCommitteeEditUrl = (id: number) =>
  `/committee-ministry/edit/${id}`;
export const regionalCommitteeListRoute = "/committee-region";
export const regionalCommitteeEditRoute = "/committee-region/edit/:id";
export const regionalCommitteeEditUrl = (id: number) =>
  `/committee-region/edit/${id}`;

export const userRoleRoute = "/users-roles";
export const roleListRoute = "/users-roles/roles";
export const userListRoute = "/users-roles/users/:roleId?";
export const userListUrl = (roleId?: number) =>
  roleId ? `/users-roles/users/${roleId}` : "/users-roles/users";
export const userDetailRoute = "/users-roles/users/user/:id";
export const userDetailUrl = (id: number) => `/users-roles/users/user/${id}`;
export const userEditRoute = "/users-roles/users/user/edit/:id";
export const userEditUrl = (id: number) => `/users-roles/users/user/edit/${id}`;

export const institutionListRoute = "/institution";
export const institutionDetailsRoute = `/institution/:id/details`;
export const institutionDetailsUrl = (id: number) =>
  `/institution/${id}/details`;
export const institutionEditRoute = `/institution/:id/edit`;
export const institutionEditUrl = (id: number) => `/institution/${id}/edit`;
export const houseNumberInstitutionListRoute = "/house-numbers";

export const requestListRoute = "/request";
export const requestCreateRoute = "/request/create";
export const requestEditRoute = "/request/edit/:id";
export const requestEditUrl = (id: number) => `/request/edit/${id}`;
export const requestDetailsRoute = "/request/:id";
export const requestDetailsUrl = (id: number) => `/request/${id}`;

export const requestAdminRoute = "/admin-request";
export const requestAdminListRoute = "/admin-request/primary";
export const requestAdminDetailsRoute = "/admin-request/primary/:id";
export const requestAdminDetailsUrl = (id: number) =>
  `/admin-request/primary/${id}`;
export const requestAdminSchoolCandidateCreateRoute =
  "/admin-request/primary/school-candidate/:id";
export const requestAdminSchoolCandidateCreateUrl = (id: number) =>
  `/admin-request/primary/school-candidate/${id}`;
export const requestSuspensionDecisionEditRoute =
  "/request/suspend-procedure/:id";
export const requestSuspensionDecisionEditUrl = (id: number) =>
  `/request/suspend-procedure/${id}`;
export const requestInstitutionEditRoute =
  "/admin-request/primary/institution/:id";
export const requestInstitutionEditUrl = (id: number) =>
  `/admin-request/primary/institution/${id}`;
export const committeeDecisionDetailsRoute =
  "/admin-request/primary/committee-decision/:committeeDecisionId/:requestId/:committeeEmployeeId";
export const committeeDecisionDetailsUrl = (
  committeeDecisionId: number,
  requestId: number,
  committeeEmployeeId: number
) =>
  `/admin-request/primary/committee-decision/${committeeDecisionId}/${requestId}/${committeeEmployeeId}`;
export const committeeDecisionEditRoute =
  "/admin-request/primary/committee-decision/edit/:committeeDecisionId/:requestId/:committeeEmployeeId";
export const committeeDecisionEditUrl = (
  committeeDecisionId: number,
  requestId: number,
  committeeEmployeeId: number
) =>
  `/admin-request/primary/committee-decision/edit/${committeeDecisionId}/${requestId}/${committeeEmployeeId}`;
export const decisionProposalEditRoute =
  "/admin-request/primary/decision-proposal/edit/:id";
export const decisionProposalEditUrl = (requestId: number) =>
  `/admin-request/primary/decision-proposal/edit/${requestId}`;
export const form7EditRoute = "/admin-request/primary/form7/edit/:id";
export const form7EditUrl = (requestId: number) =>
  `/admin-request/primary/form7/edit/${requestId}`;
export const form6EditRoute = "/admin-request/primary/form6/edit/:id";
export const form6EditUrl = (requestId: number) =>
  `/admin-request/primary/form6/edit/${requestId}`;
export const enrollmentDecisionEditRoute =
  "/admin-request/primary/enrollmentDecision/edit/:id";
export const enrollmentDecisionEditUrl = (requestId: number) =>
  `/admin-request/primary/enrollmentDecision/edit/${requestId}`;
export const enrollmentInstitutionEditRoute =
  "/admin-request/primary/enrollmentInstitution/edit/:id";
export const enrollmentInstitutionEditUrl = (requestId: number) =>
  `/admin-request/primary/enrollmentInstitution/edit/${requestId}`;
export const outsideEnrollmentAreaListRoute =
  "/admin-request/secondary/outsideEnrollmentArea";
export const outsideEnrollmentAreaListURL = () =>
  "/admin-request/secondary/outsideEnrollmentArea";
export const outsideEnrollmentAreaEditRoute =
  "/admin-request/secondary/outsideEnrollmentArea/edit/:id";
export const outsideEnrollmentAreaEditUrl = (requestId: number) =>
  `/admin-request/secondary/outsideEnrollmentArea/edit/${requestId}`;
export const languageCourseDecisionListRoute =
  "/admin-request/language-course/languageCourseDecision";
export const languageCourseDecisionEditRoute =
  "/admin-request/language-course/languageCourseDecision/edit/:id";
export const languageCourseDecisionEditUrl = (requestId: number) =>
  `/admin-request/language-course/languageCourseDecision/edit/${requestId}`;
export const languageCourseDecisionMinistryListRoute =
  "/admin-request/language-course-ministry/languageCourseDecision";
export const languageCourseDecisionMinistryEditRoute =
  "/admin-request/language-course-ministry/languageCourseDecision/edit/:id";
export const languageCourseDecisionMinistryEditUrl = (requestId: number) =>
  `/admin-request/language-course-ministry/languageCourseDecision/edit/${requestId}`;
export const medicalExaminationEditRoute =
  "/admin-request/primary/medical-examination/edit/:id";
export const medicalExaminationEditUrl = (requestId: number) =>
  `/admin-request/primary/medical-examination/edit/${requestId}`;
export const mzomAppealEditRoute =
  "/admin-request/primary/mzom-appeal/edit/:id";
export const mzomAppealEditUrl = (requestId: number) =>
  `/admin-request/primary/mzom-appeal/edit/${requestId}`;
export const registrationFormListRoute = "/admin-request/registration";
export const registrationFormEditRoute = "/admin-request/registration/edit/:id";
export const registrationFormEditUrl = (requestId: number) =>
  `/admin-request/registration/edit/${requestId}`;
export const registeredListRoute = "/admin-request/registered";

export const departmentListRoute = "/department-list";
export const requestDepartmentProgramListRoute =
  "/department-request-department-program";
export const schoolCandidateDepartmentScheduleRoute = "/department-schedule";

export const SCHOOL_ATTENDANCE_ROUTES = {
  list: `/school-attendance`,
  details: `/school-attendance/:id`,
};

export const SCHOOL_CANDIDATE_ROUTES = {
  notes: `/school-candidates/:id/school-note`,
  institutionAdminNotes: `/school-candidates-institutions-admin/:id/school-note`,
  getInstitutionAdminNotesUrl: (id: number) =>
    `/school-candidates-institutions-admin/${id}/school-note`,
  getNotesUrl: (id: number) => `/school-candidates/${id}/school-note`,
};

export const enrollmentFormEditRoute =
  "/admin-request/primary/enrollment-form/edit/:id?";
export const enrollmentFormEditUrl = (id: number | string) =>
  `/admin-request/primary/enrollment-form/edit/${id}`;
